import React, { useState } from "react";
import CustomModal from "../../../Common/Modal/CustomModal";
import { randomBetweenToNumber } from "../../../../Web/Common/Function";
function OthersPepole({
  showList,
  userDetails,
  offer,
  setOffer,
  setShowList }) {
  const [info, setInfo] = useState({});
  const [modal, setModal] = useState(false);
  const Handlerdeletepeopel = id => {
    if (offer.sendcode = true) {
      setOffer({
        code: null,
        result: null,
        sendcode: false
      });
    }
    setShowList([...showList].filter(sala => id != sala.idinfo));
  };

  return (
    <>
      <div className="row  justify-content-center p-4">
        <div className=" d-flex flex-column">
          <div className="col">
            <h6 className="headetext">همراهان شما :</h6>
          </div>
          <div className="col d-flex">
            <span className="headetext">{showList.length} نفر همراه ثبت کرده اید .</span>
          </div>
        </div>
        <div className="row justify-content-center">
          {showList.map((item, i) => {
            return (
              <div key={i} className="row detailsclass p-2 mt-3">
                {userDetails.map((key, countUser) => {
                  return (
                    <div key={countUser} className="col-12 col-md-6">
                      <label htmlFor="">{key.label} :</label>
                      <input
                        className="form-control mt-1"
                        type="text"
                        value={item[key.id]}
                        readOnly
                      />
                    </div>
                  );
                })}
                <div className="col-12 mt-2 d-flex justify-content-end">
                  <button
                    className="btn btn-danger"
                    style={{ fontSize: "10px" }}
                    onClick={() => Handlerdeletepeopel(item.idinfo)}
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="row p-4">
        <div className="row d-flex mt-1">
          <div className="col-md-10">
            <p className="paraggerf-addpeopel ">
              <i className="fas fa-exclamation" style={{ color: "red", marginLeft: '5px' }}></i>
              در صورت تمایل ثبت نام اشخاص دیگر همراه با خودتان روی کلیک
              افزودن همراه کلید کنید.
            </p>
          </div>
          <div className="col-md-2">
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-danger"
                style={{ fontSize: "11px" }}
                onClick={() => {
                  setModal(!modal);
                }}
              >
                افزودن هراه
              </button>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        show={modal}
        handleClose={() => {
          setModal(false);
        }}
        header={"افزودن همراه"}
      >
        <div className="row">
          {userDetails.map((item, key) => {
            return (
              <div key={key} className="col-12 col-md-6">
                <label htmlFor="" className="mt-1">
                  {item.label} :
                </label>
                <input
                  className="form-control mt-1"
                  type="text"
                  placeholder={item.placeholder}
                  onChange={e => {
                    setInfo({ ...info, [item.id]: e.target.value });
                  }}
                />
              </div>
            );
          })}
          <div className="col-12 mt-1">
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  let newlist = [...showList];
                  newlist.push({
                    ...info,
                    idinfo: randomBetweenToNumber(1, 9999),
                  });
                  setInfo({});
                  setShowList(newlist);
                  setModal(false);
                  if (offer.sendcode = true) {
                    setOffer({
                      code: null,
                      result: null,
                      sendcode: false
                    });
                  }
                }}
              >
                ثبت
              </button>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
}

export default OthersPepole;
